export default {
  sp: {
    common: {
      Email: 'Email',
      Account: 'Akun',
      Password: 'Kata sandi',
      Register: 'Daftar',
      Required: 'Diperlukan',
      Name: 'Nama',
      Mobile: 'Ponsel',
      Title: 'Judul',
      Message: 'Pesan',
      Verification_Code: 'Kode verifikasi',
      email_tips: 'Mohon cantumkan alamat email',
      mobile_tips: 'Mohon cantumkan nomor ponsel',
      continue: 'Berikutnya',
      send: 'Kirim',
      resend: 'Kirim ulang',
      edit: 'Sunting',
      delete: 'Hapus',
      ok: 'OK',
      confirm: 'Konfirmasi',
      save: 'Simpan',
      cancel: 'Batal',
      change: 'Ganti',
      close: 'Tutup',
      select: 'Pilih',
      apply: 'Terapkan',
      are_you_sure_to_delete_it: 'Apakah anda yakin untuk menghapus ini?',
      full_name: 'Nama lengkap',
      u_full_name: 'Nama lengkap anda',
      mobile_phone: 'Nomor ponsel',
      u_email_address: 'Alamat e-mail anda',
      promo_code: 'Kode promosi',
      no_data: 'Tidak ada data',
      view_more: 'Lihat lebih',
      learn_more: 'Pelajari lebih lanjut',
      promotion_has_ended: 'Mohon maaf, promosi ini telah berakhir.',
      end: 'Akhir',
      SKU: 'SKU:',
      quantity: 'Jumlah:',
      delivery: 'Pengiriman:',
      success: 'Sukses',
      you_may_also_like: 'Anda mungkin akan suka',
      sale: 'SALE',
      password_valid_tips:
        'Harus menggunakan huruf karakter alphanumeric dan paling sedikit 6 huruf ',
      billing_address: 'Alamat Penagihan',
      company_address: 'Alamat perusahaan',
      days: 'Hari',
      hours: 'Jam',
      minutes: 'Menit',
      seconds: 'Detik',
      start_in: 'Mulai di',
      end_in: 'Berakhir di',
      it_is_over: 'Telah berakhir',
      find_products_in_store: 'Cari barang di toko ini',
      details: 'Detail',
      specification: 'Spesifikasi',
      perfect_companion: 'Pelengkap terbaik',
      are_you_sure_delete_it: 'Apakah anda yakin untuk menghapus nya?',
      are_you_sure_delete_product:
        'Apakah anda yakin untuk menghapus produk nya?',
      are_you_sure_to_delete_invalid_products:
        'Apakah anda yakin untuk menghapus barang yang tidak valid?',
      select_a_store: 'Pilih toko',
      select_one_item_least: 'Mohon pilih satu produk',
      my_account: 'Akun saya',
      my_orders: 'Pesanan saya',
      my_address: 'Alamat saya',
      xx_installment_tax: '{name} cicilan {n}%',
      n_months: '{n       } bulan',
      price_month: '{price}/per bulan',
      must_member_login_tips:
        'Anda telah terdaftar sebagai member, mohon login untuk melihat lebih lanjut',
      are_you_sure_to_receive_the_order:
        'Apakah anda yakin untuk menerima pesanan ini?',
      are_you_sure_to_cancel_the_order:
        'Apakah anda yakin untuk membatalkan pesanan ini?',
      filter_by: 'Fliter dengan',
      password_updated_successfully_tips:
        'Password berhasil diperbarui, mohon login kembali.',
      validation_code_sent_successfully: 'Kode validasi berhasil dikirim!',
      your_registration_is_successful: 'Registrasi berhasil!',
      verification_code_sent_email_tips:
        'Kode validasi telah dikirim, mohon untuk melihat email anda.',
      verification_code_is_incorrect_tips:
        'Kode validasi salah, mohon untuk periksa kembali.',
      i_accept_x: 'Saya menyetujui',
      privacy_policy: 'Kebijakan Privasi',
      term_conditions: 'Syarat & Ketentuan',
      sign_in: 'Masuk',
      return: 'Pengembalian',
      return_details: 'Detil Pengembalian',
      reason: 'Alasan',
      are_you_sure_to_return_the_order:
        'Apakah anda yakin untuk mengembalikan pesanan ini?',
      logistics_info: 'Info pengiriman',
      logistics_company: 'Jasa kirim',
      tracking_no: 'No resi',
      not_receive_tips:
        'Ada item yang belum terkirim, pesanan tidak dapat ditandatangani',
      undo_return: 'Batalkan Pengembalian',
      yes: 'Ya',
      no: 'Tidak'
    },
    login: {
      or: 'Atau',
      login: 'Masuk',
      error_tips: 'Nama akun atau kata sandi salah',
      Forgot_passwords: 'Lupa Kata Sandi?',
      register_now: 'Daftar',
      Send_email: 'Kirim kode verifikasi ke email',
      Log_in: 'Masuk',
      create_account: 'Daftar',
      forgot_password: 'Lupa Kata Sandi',
      account_Email: 'Akun / Email',
      send_email: 'Kirim kode verifikasi ke email',
      Recovery_Code: 'Kode verifikasi',
      New_Password: 'Kata sandi baru',
      Change_Password: 'Atur ulang kata sandi',
      Sign_in_with_Google: 'Masuk dengan Google',
      Sign_in_with_Facebook: 'Masuk dengan Facebook',
      guest_checkout: 'Checkout',
      guest_checkout_desc1: 'Checkout sekarang',
      guest_checkout_desc2: 'Anda dapat membuat akun setelah process checkout',
      already_member_verify:
        'Anda telah menjadi member, mohon untuk masuk dengan akun anda',
      returning_user: 'Sudah terdaftar?',
      sign_in_to_use_saved_information:
        'Masuk untuk menggunakan informasi yang telah tersimpan',
      enter_correct_name_or_password:
        'Mohon cantumi akun atau kata sandi yang benar',
      have_account: 'Sudah punya akun?',
      back_to_login: 'Kembali ke halaman masuk',
      Not_same_as_the_password_first_time:
        'Tidak sama dengan kata sandi yang Anda masukkan untuk pertama kali',
      reset_email_link_tips:
        'Masukan email anda dan kami akan mengirimkan link untuk atur ulang kata sandi.',
      mobile_number: 'Nomor ponsel',
      account_creation_instructions_x: "By creating an account, you agree to the MAPCLUB’s",
      and: "dan",
      account_creation_instructions: "Dengan membuat akun, Anda menyetujui",
      verify_identity: 'Verifikasi Identitas',
      send_code_tips:
        'Speedshop telah mengirim kode verifikasi ke <span>{account}</span>.<br/>Mohon masukan kode di kolom tersedia',
      verify_identity_message:
        'Kami melihat adanya aktivitas yang tidak biasa pada akun Speedshop Anda. Demi keamanan Anda, kami ingin memastikan bahwa ini benar-benar Anda.'

    },
    store: {
      contact: 'Kontak',
      hint: 'Petunjuk peta'
    },
    contact: {
      send_message: 'Kirim pesan',
      contact_us: 'Hubungi kami',
      submit_succeeded: 'Pengiriman berhasil',
      contact_us_tips:
        'Kami akan menghubungi anda sesegera mungkin. Mohon menunggu.'
    },
    account: {
      hello: 'Halo, {name}',
      welcome: 'Selamat datang ke {site}.',
      LOGOUT: 'Keluar',
      user: 'User',
      my_order: 'Pesanan Saya',
      my_coupon: 'Kupon Saya',
      my_wishlist: 'Daftar Keinginan Saya',
      account_setting: 'Pengaturan Akun'
    },
    order: {
      home_delivery: 'Pengiriman ke rumah',
      store_pickup: 'Pengambilan di toko',
      my_order: 'Pesanan Saya',
      n_orders: '({n} Pesanan)',
      pay_now: 'Bayar sekarang',
      order_details: 'Detil Pesanan',
      end: 'akhir',
      no_orders: 'No. Pesanan ',
      cancel: 'Batal',
      n_products: 'Produk',
      order_list: 'Daftar pesanan',
      product_list: 'Daftar produk',
      pickup_code: 'Kode pickup',
      receive_order: 'Terima Pesanan',
      orders_made: 'Pesanan terbuat',
      online_invoice: 'Invoice online',
      order_status: 'Status pesanan',
      offline_invoice: 'Invoice offline',
      time: 'Waktu',
      shipping_method: 'Methode pengiriman',
      shipping_code: 'Kode pengiriman',
      shipping_fee: 'Biaya Pengiriman',
      shipping_address: 'Alamat pengiriman',
      full_name: 'Nama lengkap',
      phone: 'Ponsel',
      address: 'Alamat',
      payment_info: 'Informasi pembayaran',
      payment_method: 'Metode Pembayaran',
      payment_status: 'Status pembayaran',
      payment_time: 'Waktu pembayaran',
      value: 'Nilai',
      sku: 'SKU',
      price: 'Harga',
      qty: 'Jumlah',
      total_n_products: 'Total produk',
      discount: 'Diskon',
      voucher: 'Voucher',
      total: 'Total',
      subtotal: 'Subtotal',
      coupon_discount: 'Kupon Diskon',
      subtotal_n_products: 'Subtotal ({n} produk)',
      track_your_order: 'Lacak pesanan anda',
      track_your_order_desc:
        'Mohon isi alamat email anda sewaktu anda membuat pesanan.',
      invoice: 'Faktur',
      Return_Refund_detail: 'Kembali/Pengembalian Dana Detail',
      undo_return: 'Urungkan Kembali',
      fill_logistics_info: 'Isi Info Logistik',
      refund: 'Pengembalian uang',
      delivery_method: 'Metode Pengiriman',
      rate_and_review:'Rate and Review'
    },
    payment: {
      payment: 'Pembayaran',
      your_order_no_is_xx: 'Kode pesanan anda.{orderCode}',
      thank_you_for_your_purchase: 'Terima kasih atas pembelian Anda!',
      pay_result_success_tips:
        'Kami akan mengirimkan email konfirmasi pesanan dengan detail dan info pelacakan pesanan anda.',
      continue_shopping: 'Lanjut berbelanja',
      something_went_wrong: 'Terdapat Kesalahan',
      the_transaction_is_unsuccessful: 'Transaksi Gagal',
      please_contact_customer_service:
        'Silahkan menghubungi Tim Customer Service kami',
      view_details: 'Lihat rincian',
      order_is_processing: 'Pesanan di proses'
    },
    address: {
      address: 'Alamat',
      add_new_address: 'Tambah alamat baru',
      Please_save_the_billing_address_at_first:
        'Mohon simpan alamat penagihan terlebih dahulu',
      please_save_the_shipping_address_at_first:
        'Mohon simpan alamat pengiriman terlebih dahulu',
      corporate: 'Korporat',
      personal: 'Pribadi',
      company_name: 'Nama perusahaan',
      your_company_name: 'Nama perusahaan anda',
      tax_code: 'Kode pajak',
      u_tax_code: 'Kode pajak anda',
      first_name: 'Nama depan',
      your_first_name: 'Nama depan anda',
      last_name: 'Nama belakang',
      your_last_name: 'Nama belakang anda',
      contact_number: 'Nomor kontak',
      please_input_the_correct_phone_number:
        'Silakan masukkan nomor telepon yang benar',
      email: 'E-mail',
      email_address: 'Alamat e-mail anda',
      please_input_the_correct_email_address:
        'Silakan masukkan alamat e-mail yang benar',
      state_Province: 'Provinsi',
      county_city: 'Kabupaten',
      town_districts: 'Kota/Daerah',
      postal_code: 'Kode pos',
      zip_postal_Code: 'Kode pos',
      city: 'Kota',
      select_county_city: 'Pilih kabupaten',
      province: 'Provinsi',
      districts: 'Daerah',
      select_province: 'Pilih provinsi',
      your_mobile_phone: 'Nomor ponsel anda',
      country: 'Negara',
      zip_code_valid: 'Silakan masukkan nomor valid 5 digit di medan ini.',
      my_address: 'Alamat Saya'
    },
    checkout: {
      please_check_the_form: 'Silahkan cek formulirnya',
      checkout: 'Checkout',
      ship_to: '1. Dikirim ke',
      pay_with: '2. Pembayaran dengan',
      back_to_cart: 'Kembali ke keranjang',
      coupon: 'Kupon',
      choose_coupon: 'Pilih kupon',
      billing_address_same_as_shipping:
        'Alamat penagihan sesuai dengan alamat pengiriman',
      find_the_nearest_store: 'Temukan toko terdekat dari lokasi anda',
      store_location: 'Lokasi toko',
      pick_up_at: '1. Penjemputan di',
      store_info: 'Informasi Toko'
    },
    pdp: {
      sold_out: 'Habis terjual',
      installment_simulation: '{n}% Simulasi cicilan',
      add_to_cart: 'Tambah ke keranjang',
      stock_status: 'Status stok:',
      stock_available: 'Stok tersedia:',
      remind_when_available: 'Ingatkan saat tersedia',
      please_select_a_attrname: 'Silahkan pilih {attrName}',
      no_available_coupons: 'Kupon tidak tersedia',
      product_not_available:"Habis terjual",
      customer_reviews:'Customer Reviews'
    },
    plp: {
      filter: 'Filter',
      clear_all: 'Hapus semua',
      current_page_total_item: '{currentPage}/{total} item',
      search_results_for_product: 'Hasil pencarian untuk produk ({n})',
      all_product_n: 'Semua produk ({n})',
      no_results_were_found: 'Mohon maaf, tidak ada hasil yang ditemukan',
      BRAND: 'Merek',
      CATEGORY: 'Koleksi',
      SIZE: 'Ukuran',
      COLOR: 'Warna',
      STOCK: 'Stok',
      PRICE: 'Harga'
    },
    shop_cart: {
      all_products: 'Semua produk',
      invalid_products: 'Produk salah',
      home_delivery: 'Pengiriman ke rumah',
      home_delivery_desc: 'Pesanan anda akan dikirim ke alamat yang anda pilih',
      pick_up_at_store: 'Ambil di toko',
      pick_up_at_store_desc: 'Ambil pesanan lansung di toko pilihan anda',
      Your_cart_amount_is_total_price: 'Jumlah di keranjang anda  {totalPrice}',
      shopping_cart: 'Keranjang belanja',
      order_summary: 'Ringkasan Pesanan',
      n_items: '({n} produk)',
      cart_empty: 'Keranjang belanjamu kosong',
      select_city: 'Silahkan pilih kota',
      no_available_stores:
        'Tidak ada toko yang tersedia untuk produk yang dipilih'
    },
    subscribe: {
      subscribe_tips: 'Terima kasih telah mendaftar untuk buletin digibox.',
      email_placeholder: 'Masukan alamat email',
      newsletter: 'Berlangganan',
    },
    coupon: {
      my_coupon: 'Kupon saya',
      unused_n: 'Belum terpakai ({n})',
      used_n: 'Terpakai ({n})',
      expired_n: 'Kedaluwarsa ({n})\n',
      expired: 'Kedaluwarsa\n',
      no_available_coupons: 'Tidak ada kupon tersedia.',
      no_details: 'Tidak ada detail.'
    },
    account_setting: {
      account_setting: 'Pengaturan akun',
      edit_xx: 'Ubah  {title}'
    },
    wishlist: {
      my_wishlist: 'Daftar Keinginan Saya',
      no_any_items: 'Anda belum menyimpan produk.'
    },
    points: {
      use_x_points: 'Gunakan {x} poin',
      use_x_points_m: 'Gunakan {x} poin?',
      available_points_n: 'Poin tersedia: {n}',
      redeem: 'Tukarkan',
      sign_in_sign_up: 'Masuk atau daftar'
    }
  }
}
